module.exports = __webpack_public_path__ + "static/media/Nodata.4de11c96.png";